import apiClient from '@/api/ApiClient';
import { DonationPageConfig } from './types';

export interface BranchDto {
  id: number;
  name: string;
}

export interface BankDto {
  name: string;
  branches: BranchDto[];
}

export async function fetchBanks(): Promise<Record<string, BankDto>> {
  const { data } = await apiClient.get<Record<string, BankDto>>('banks');
  return data;
}

export interface SubmitOfflineDonationPayload {
  type: 'Check' | 'BankTransfer';
  donorFirstName: string;
  donorLastName: string;
  donorIsraeliId: string;
  donorPhone: string;
  donorEmail: string;
  donorAddress: string;
  donorCity: string;
  amount: number;
  currency: string;
  reference?: string;
  checkNumber?: string;
  bankNumber?: string;
  branchNumber?: string;
  accountNumber?: string;
  checkSubType?: 'ForDeposit' | 'Deposited';
  destBankNumber?: string;
  destBranchNumber?: string;
  destAccountNumber?: string;
  proofFileName?: string;
  proofFileBase64?: string;
  secondProofFileName?: string;
  secondProofFileBase64?: string;
  maturityDate?: string;
}

export async function updateDestinationBankAccount(
  donationId: number,
  destBankNumber: string,
  destBranchNumber: string,
  destAccountNumber: string,
): Promise<void> {
  await apiClient.patch(`donations/pending/${donationId}/destination-bank`, { destBankNumber, destBranchNumber, destAccountNumber });
}

export interface SubmitOfflineDonationResponse {
  id: number;
}

export async function fetchDonationPageConfig(fundId: number): Promise<DonationPageConfig> {
  const { data } = await apiClient.get<DonationPageConfig>(`donations/page-config/${fundId}`);
  return data;
}

export async function submitOfflineDonation(
  fundId: number,
  payload: SubmitOfflineDonationPayload
): Promise<SubmitOfflineDonationResponse> {
  const { data } = await apiClient.post<SubmitOfflineDonationResponse>(`donations/offline/${fundId}`, payload);
  return data;
}

export interface CreateOnlineDonationPayload {
  paymentType: string;
  donorFirstName: string;
  donorLastName: string;
  donorIsraeliId: string;
  donorPhone: string;
  donorEmail: string;
  donorAddress: string;
  donorCity: string;
  amount: number;
  currency: string;
  callbackBaseUrl: string;
}

export interface CreateOnlineDonationResponse {
  redirectUrl: string;
  transactionId: string;
  trackingId?: string;
  message: string;
}

export async function createOnlineDonation(
  fundId: number,
  payload: CreateOnlineDonationPayload
): Promise<CreateOnlineDonationResponse> {
  const { data } = await apiClient.post<CreateOnlineDonationResponse>(`donations/online/${fundId}`, payload);
  return data;
}

export async function getOnlineDonationStatus(trackingId: string): Promise<string> {
  const { data } = await apiClient.get<{ status: string }>(`donations/online-status/${trackingId}`);
  return data.status;
}
